import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import UserHelper from '@helpers/user';
import { INTRO_STEP } from '@consts/app';
import { SETTING_TABS } from '@consts/settings';
import { LOGIN_CHANNEL } from '@consts/account';
import { login, setLoginFormData, hideLoginError, loginFail } from '@actions/user';
import { jumpTo } from '@actions/app';
import epassportActions from '@actions/epassport';
import { setDsStatus } from '@actions/dsStatus';
import LoginForm from '@components/user/login-form';
import Upgrade from '@containers/upgrade';
import Epassport from '@components/epassport';
import { HistoryUtils } from 'x-react-router';
import Utils from '@core/utils';

const { queryToJson } = Utils;

class Login extends Component {
  static cid = '登录';
  static propTypes = {
    username: PropTypes.string,
    password: PropTypes.string,
    err: PropTypes.string,
    succMsg: PropTypes.string,
    timestamp: PropTypes.number,
    loginType: PropTypes.string,
    login: PropTypes.func,
    setLoginFormData: PropTypes.func,
    hideLoginError: PropTypes.func,
    jumpTo: PropTypes.func,
    loginFail: PropTypes.func,
    hasEpassErr: PropTypes.bool,
    hasEpassErrWithCode: PropTypes.bool,
    heightResizeWithCode: PropTypes.func,
    needVerify: PropTypes.bool,
    setDsStatus: PropTypes.func,
  };

  componentWillMount() {
    UserHelper.resetAuth();
    this.props.setDsStatus(0);
    window.PmsBridge && window.PmsBridge.events.trigger('__logout__');
    if (window.location.search) {
      let queryParam = queryToJson(window.location.search.slice(1));
      queryParam.channel = LOGIN_CHANNEL.EB;
      queryParam.token ? this.props.login(queryParam) : queryParam;
      queryParam.phoneNum ? this.props.setLoginFormData({ username: queryParam.phoneNum }) : '';
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.logon && nextProps.timestamp !== this.props.timestamp) {
      // 新用户引导，自动跳转至门店设置页
      if (nextProps.intro === INTRO_STEP.SHOW_HOTEL_FORM) {
        this.props.jumpTo({ path: `settings/${SETTING_TABS.HOTEL_SETTING}` });
      } else {
        this.props.jumpTo({ path: 'home' });
      }
      this.props.hideLoginError();
    }
  }
  changeLoginType(loginType) {
    this.props.hideLoginError();
    this.props.jumpTo({
      path: 'login',
      param: loginType ? { loginType } : {},
    });
  }
  emptyFunc() {}
  renderMain() {
    const isEpassport = this.props.loginType !== 'mobile';
    const { username, password, err, succMsg } = this.props;
    const props = this.props;
    let switchBtnToTop;
    if (props.hasEpassErrWithCode) {
      switchBtnToTop = '-2px';
    } else if (props.hasEpassErr) {
      switchBtnToTop = '-68px';
    } else {
      switchBtnToTop = '-118px';
    }
    return (
      <div className="login-main">
        <LoginForm
          cid={Login.cid}
          username={username}
          password={password}
          err={err}
          succMsg={succMsg}
          setFormData={(name, value) => this.props.setLoginFormData({ [name]: value })}
          onLogin={() => {
            props.login({ username, password, channel: LOGIN_CHANNEL.DINGDANG, mempasswd: true });
          }}
          // onRegister={() => props.jumpTo({
          //   path: 'register',
          // })}
          // onFindPwd={() => props.jumpTo({
          //   path: 'findpwd',
          // })}
          needVerify={this.props.needVerify}
          style={{ display: !isEpassport ? 'block' : 'none' }}
        />
      </div>
    );
  }

  render() {
    const that = this;
    window.onmessage = (msg) => {
      const msgData = msg.data;
      if (!msgData || msgData[0] !== '{') return;
      try {
        const result = JSON.parse(msgData);
        const epassHeight = result.height;
        if (result.type === 'EPASSPORT_HEIGHT_RESIZE') {
          if (this.props.loginType !== 'mobile') {
            if (epassHeight > 250 && epassHeight < 300) {
              that.props.heightResizeWithCode();
            } else if (epassHeight >= 300) {
              that.props.heightResizeWithCode(true);
            }
          }
        }
      } catch (e) {
        window.logger.error(e);
      }
    };
    return (
      <div>
        <div className="login-content">
          <div className="login-panel">
            <header>
              <h1 className="login-title">
                <img src={require('@resource/logo_big.png')} title="金块管家" alt="金块管家" />
              </h1>
            </header>
            {this.renderMain()}
            <div className="phone" style={{ bottom: this.props.needVerify ? '0' : '50px' }}>
              <p>便捷高效的酒店管理系统,提高酒店客房管理速度</p>
              {/* <p>如有问题请拨打客服电话</p>
              <p>13869663133</p> */}
            </div>
            <footer style={{ bottom: this.props.needVerify ? '-40px' : '10px' }}>
              <p>版权信息 Copyright &copy;</p>
            </footer>
          </div>
        </div>
        <Upgrade />
      </div>
    );
  }
}

function mapStateToProps({ loginFormData, intro, router, epassport, hotels }) {
  return { ...loginFormData,
    intro: intro.newUserIntro,
    loginType: router.param.loginType,
    hasEpassErr: epassport.epassportHeight.hasEpassErr,
    hasEpassErrWithCode: epassport.epassportHeight.hasEpassErrWithCode,
    hotels,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    login,
    setLoginFormData,
    hideLoginError,
    jumpTo,
    loginFail,
    ...epassportActions,
    setDsStatus,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./containers/login/index.js